module.exports = __webpack_public_path__ + "static/media/HugoBoss-JosephSchooling-500x250-Animated.fb1ff034.mp4";